import bootbox from 'bootbox';
import {defineMessages, IntlProvider, IntlShape} from 'react-intl';
import {getLocale} from '../../browser/locales';
import {getMessages} from '../../browser/getMessages';

const {intl} = new IntlProvider({locale: getLocale(), messages: getMessages()}, {}).getChildContext();

import './ConfirmDialog.scss';
import './ErrorDialog.scss';

const messages = defineMessages({
    title: {id: 'ErrorDialog.title', defaultMessage: 'Mutation Error'},
    cancel: {id: 'common.close', defaultMessage: 'Close'}
});

/**
 * Show confirm dialog with unified style and default configuration
 * @param  {object} config Configuration of confirm dialog:
 *               * message {string, required} Main text of the dialog, could contain html elements (like <br />, <strong>, ect.)
 * @return {Promise}        Resovle on confirm, reject on cancel
 */
export default function errorDialog(config) {
    return new Promise((resolve, reject) => {
        bootbox.alert({
            className: 'ConfirmDialog ErrorDialog',
            title: intl.formatMessage(messages.title),
            message: config.message + '<br /><br /><span class="errorNo">Error no.: ' + config.id + '</span>',
            buttons: {
                ok: {
                    label: intl.formatMessage(messages.cancel),
                    className: "btn-default"
                }
            }
        });
    });
}
